// removed by extract-text-webpack-plugin
module.exports = {"toast":"_2HfMvHtlrH1bgR4ixdJKiw_0"};


//////////////////
// WEBPACK FOOTER
// ./~/extract-text-webpack-plugin/loader.js?{"omit":1,"remove":true,"publicPath":"/m/"}!./~/vue-style-loader!./~/css-loader?{"minimize":true,"sourceMap":true,"localIdentName":"[hash:base64]_0","modules":true,"importLoaders":true}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-1b92dde5","scoped":false,"hasInlineConfig":false}!./~/px2rem-loader?{"remUnit":37.5}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/common/toast.vue
// module id = 172
// module chunks = 45